import React from "react";
import { useAppSelector } from "../../store/index.ts";
import GameItem from "../mui/game_tem/GameItem.jsx";

export default function LiveGames() {
  const games = useAppSelector((state) => state.games.liveGames);

  console.log("games", games);

  return (
    <div className="games__games">
      {games.map((el) => (
        <GameItem currentGame={el} key={el.game_id} name={el.name} image={el.image} />
      ))}
    </div>
  );
}
